<template>
  <div>
    <router-link
      to="add/task"
      class="uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
      >Shto</router-link
    >
    <div>
      <OverLoadTable :date="date" :user="user" />
    </div>
    <TasksTable :date="date" :user="user" />
    <div>
      <EmailsTable :date="date" :user="user" />
    </div>
    <div>
      <SimilarTasksTable :date="date" :user="user" />
    </div>
    <div>
      <UnfinishedTasksTable :date="date" :user="user" />
    </div>
    <div>
      <AmPriorityTasksTable :date="date" :user="user" />
    </div>
    <div>
      <PmPriorityTasksTable :date="date" :user="user" />
    </div>
    <div>
      <DailyTasksTable :date="date" :user="user" />
    </div>
    <div>
      <router-link
        to="add/other"
        class="uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
        >Shto</router-link
      >
      <IssuesTable :date="date" :user="user" />
    </div>
    <div>
      <PurposesTable :date="date" :user="user" />
    </div>
    <div>
      <OverLoadTableTomorrow :date="date" :user="user" />
    </div>

    <div>
      <router-link
        v-if="!this.graded"
        :to="{ path: '/days/add-ratings', query: { date: date } }"
        class="uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
        >Shto Vleresim</router-link
      >
      <RatingsTable :date="date" :user="user" />
    </div>
  </div>
</template>

<script>
import TasksTable from "./TasksTable";
import EmailsTable from "./EmailsTable";
import SimilarTasksTable from "./SimilarTasksTable";
import UnfinishedTasksTable from "./UnfinishedTasksTable";
import AmPriorityTasksTable from "./AmPriorityTasksTable";
import PmPriorityTasksTable from "./PmPriorityTasksTable";
import DailyTasksTable from "./DailyTasksTable";
import IssuesTable from "./IssuesTable";
import PurposesTable from "./PurposesTable";
import OverLoadTable from "./OverLoadTable";
import OverLoadTableTomorrow from "./OverLoadTableTomorrow";
import RatingsTable from "./RatingsTable";
import axios from "axios";

export default {
  props: {
    date: String,
    user: Number,
  },
  components: {
    TasksTable,
    EmailsTable,
    SimilarTasksTable,
    UnfinishedTasksTable,
    AmPriorityTasksTable,
    PmPriorityTasksTable,
    DailyTasksTable,
    IssuesTable,
    PurposesTable,
    OverLoadTable,
    OverLoadTableTomorrow,
    RatingsTable,
  },
  data() {
    return {
      pm_title: "",
      pm_status: "",
      pm_time: "",
      pm_comment: "",
      graded: false,
      errorTask: false,
    };
  },
  created() {
    this.getGraded();
  },
  watch: {
    date: function() {
      this.getGraded();
    },
  },
  methods: {
    getGraded() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/vlersimet?day=${this.date}`)
        .then((response) => {
          this.graded = response.data.deriSot.vleresuar;
        });
    },
  },
};
</script>

<style></style>
